module.exports = __webpack_public_path__ + "img/8F4277_361530_BF538E_52274C-256px.0810ee55.png";